import React from 'react';

export const name = 'flag-GB';

export const FlagGB = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_27)">
      <g mask="url(#mask0_1_27)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#EEEEEE"
        />
        <path
          d="M2.48437 4.69219C1.5263 5.93489 0.822281 7.35408 0.412491 8.86875H6.65625L2.48437 4.69688V4.69219ZM23.5875 8.86875C23.1786 7.35605 22.4761 5.93855 21.5203 4.69688L17.3484 8.86875H23.5828H23.5875ZM0.412491 15.1313C0.821438 16.6439 1.52382 18.0615 2.47968 19.3031L6.65156 15.1313H0.421866H0.412491ZM19.3031 2.47968C18.061 1.52549 16.6436 0.82471 15.1313 0.417178V6.65625L19.3031 2.48437V2.47968ZM4.69688 21.5203C5.94033 22.4751 7.35947 23.1758 8.87344 23.5828V17.3438L4.70156 21.5156L4.69688 21.5203ZM8.86875 0.412491C7.35605 0.821438 5.93855 1.52382 4.69688 2.47968L8.86875 6.65625V0.412491ZM15.1313 23.5875C16.6439 23.1786 18.0615 22.4761 19.3031 21.5203L15.1313 17.3484V23.5828V23.5875ZM17.3438 15.1313L21.5156 19.3031C22.4731 18.0618 23.1771 16.6443 23.5875 15.1313H17.3438Z"
          fill="#0052B4"
        />
        <path
          d="M23.8969 10.4344H13.5656V0.103125C13.0465 0.0349757 12.5235 0.000528553 12 0C11.4703 0 10.9453 0.0328125 10.4344 0.103125V10.4344H0.103125C0.0349757 10.9535 0.000528553 11.4765 0 12C0 12.5297 0.0328125 13.0547 0.103125 13.5656H10.4344V23.8969C11.4737 24.0323 12.5263 24.0323 13.5656 23.8969V13.5656H23.8969C23.965 13.0465 23.9995 12.5235 24 12C24 11.4703 23.9672 10.9453 23.8969 10.4344Z"
          fill="#D80027"
        />
        <path
          d="M15.1312 15.1312L20.4844 20.4844C20.7297 20.2384 20.9643 19.9819 21.1875 19.7156L16.6078 15.1312H15.1312ZM8.86875 15.1312L3.51562 20.4844C3.7616 20.7297 4.01809 20.9643 4.28438 21.1875L8.86875 16.6078V15.1312ZM8.86875 8.86875L3.51562 3.51562C3.27026 3.7616 3.03566 4.01809 2.8125 4.28438L7.39219 8.86875H8.86875ZM15.1312 8.86875L20.4844 3.51562C20.2384 3.27024 19.9819 3.03565 19.7156 2.8125L15.1312 7.39219V8.86875Z"
          fill="#D80027"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1_27">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
